export const profileDataAgreements = (name: string): string[] => ['agreements', name];
export const profileDataProfile = (name: string): string[] => ['profile', name];
export const profileDataNotifications = (name: string): string[] => ['notifications', name];

